var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/20px/More-vertical"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77734 9.99999C7.77734 8.77269 8.77227 7.77777 9.99957 7.77777C11.2269 7.77777 12.2218 8.77269 12.2218 9.99999C12.2218 11.2273 11.2269 12.2222 9.99957 12.2222C8.77227 12.2222 7.77734 11.2273 7.77734 9.99999Z",
    fill: "#848B9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77734 2.22222C7.77734 0.994923 8.77227 0 9.99957 0C11.2269 0 12.2218 0.994923 12.2218 2.22222C12.2218 3.44952 11.2269 4.44444 9.99957 4.44444C8.77227 4.44444 7.77734 3.44952 7.77734 2.22222Z",
    fill: "#848B9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77734 17.7778C7.77734 16.5505 8.77227 15.5555 9.99957 15.5555C11.2269 15.5555 12.2218 16.5505 12.2218 17.7778C12.2218 19.0051 11.2269 20 9.99957 20C8.77227 20 7.77734 19.0051 7.77734 17.7778Z",
    fill: "#848B9A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDots);
export default __webpack_public_path__ + "static/media/menu-dots.91aa132cd9be2aa09c9a20dbb9057242.svg";
export { ForwardRef as ReactComponent };